import { render } from "./Anagram.vue?vue&type=template&id=65dbc5e3&scoped=true&ts=true"
import script from "./Anagram.vue?vue&type=script&lang=ts"
export * from "./Anagram.vue?vue&type=script&lang=ts"

import "./Anagram.vue?vue&type=style&index=0&id=65dbc5e3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65dbc5e3"]])

export default __exports__